// Composant du lien d'invitation
const InviteLink = ({ currentTheme, onClick, t }) => {
  return (
    <button
      className="text-blue-400 hover:text-blue-600 font-semibold underline text-sm transition-colors"
      onClick={onClick}
    >
      {t('inviteText')}
    </button>
  );
};
import React, { useState } from 'react';
import { Search, Bell, User, ChevronDown, X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSelector from './LanguageSelector';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';

const Header = ({ onSearchChange, searchQuery = '', onInviteClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const { themeConfig } = useTheme();
  const { t } = useLanguage();

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const clearSearch = () => {
    if (onSearchChange) {
      onSearchChange('');
    }
    setIsSearchExpanded(false);
  };

  const toggleSearch = () => {
    setIsSearchExpanded(!isSearchExpanded);
    if (isSearchExpanded) {
      clearSearch();
    }
  };

  const currentDomain = window.location.hostname;
  const brandingImage = `/images/logo-${currentDomain}.png`;


  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/90 backdrop-blur-sm' : 'bg-gradient-to-b from-black/60 to-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-6 py-4">
        {/* Left Section */}
        <div className="flex items-center space-x-8">
          {/* Logo */}
          <div className="text-red-600 font-bold text-2xl tracking-tight">
            <img 
              // src={themeConfig.branding.logo || "/images/logo-ragescream.png"} 
              src={brandingImage || "/images/logo-fabiomeyer.png"}
              alt={`${themeConfig.name} Logo`} 
              className="h-8" 
            />
          </div>
          
          {/* Navigation */}
          <nav className="hidden md:flex space-x-6">
            <a href="#" className="text-white hover:text-gray-300 transition-colors">Home</a>
          </nav>
          
          {/* Lien d'invitation - visible uniquement pour standup-comedy, ragescream et leurs localhost */}
          {/* {(window.location.hostname === 'standup-comedy.ch' || window.location.hostname === 'xxxragescream.com' || window.location.hostname === 'localhost' && (window.location.port === '3003' || window.location.port === '30011111')) && (
            <div className="ml-6">
              <InviteLink currentTheme={themeConfig.id} onClick={onInviteClick} t={t} />
            </div>
          )} */}
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-4">
          {/* Search */}
          <div className="flex items-center space-x-2">
            {/* Mobile Search Toggle */}
            <Button
              variant="ghost"
              size="sm"
              className="md:hidden p-2 text-white hover:bg-white/10"
              onClick={toggleSearch}
            >
              {isSearchExpanded ? <X className="w-5 h-5" /> : <Search className="w-5 h-5" />}
            </Button>
            
            {/* Desktop Search */}
            <div className="hidden md:flex items-center space-x-2">
              <Search className="w-5 h-5 text-white" />
              <div className="relative">
                <Input 
                  placeholder={t('search')} 
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="bg-black/50 border-white/20 text-white placeholder:text-gray-400 w-64 pr-8"
                />
                {searchQuery && (
                  <Button
                    variant="ghost"
                    size="sm"
                    className="absolute right-1 top-1/2 transform -translate-y-1/2 p-1 h-6 w-6 text-gray-400 hover:text-white"
                    onClick={clearSearch}
                  >
                    <X className="w-4 h-4" />
                  </Button>
                )}
              </div>
            </div>
          </div>

          {/* Language Selector */}
          <LanguageSelector />

          {/* Theme Switcher - Visible seulement sur localhost */}
          {window.location.hostname === 'localhost' && (
            <ThemeSwitcher className="hidden md:block" />
          )}

          {/* Masqué: Notifications */}
          {false && (
            <Button variant="ghost" size="sm" className="p-2 text-white hover:text-gray-300">
              <Bell className="w-5 h-5" />
            </Button>
          )}

          {/* Masqué: Profile */}
          {false && (
            <div className="flex items-center space-x-2 cursor-pointer group">
              <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
                <User className="w-5 h-5 text-white" />
              </div>
              <ChevronDown className="w-4 h-4 text-white group-hover:rotate-180 transition-transform" />
            </div>
          )}
        </div>
      </div>
      
      {/* Mobile Search Bar */}
      {isSearchExpanded && (
        <div className="md:hidden px-6 pb-4 bg-black/90 backdrop-blur-sm">
          <div className="relative">
            <Input 
              placeholder={t('search')} 
              value={searchQuery}
              onChange={handleSearchChange}
              autoFocus
              className="bg-black/50 border-white/20 text-white placeholder:text-gray-400 w-full pr-8"
            />
            {searchQuery && (
              <Button
                variant="ghost"
                size="sm"
                className="absolute right-1 top-1/2 transform -translate-y-1/2 p-1 h-6 w-6 text-gray-400 hover:text-white"
                onClick={clearSearch}
              >
                <X className="w-4 h-4" />
              </Button>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;